/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import moment from "moment";
import PropTypes from "prop-types";
import {DropdownItem, UncontrolledTooltip} from "reactstrap";
import {useDispatch} from "react-redux";
import {markNotificationAsRead} from "../../redux/Actions/notifications.action";
import "./notification.scss";

/** Notification Details Component
 * Displays notification details when a notification is created.
 * Indicates whether the notification has been read.
 * If unread, clicking the notification message triggers an API call to mark it as read.
 */

const NotificationItem = (props) => {
  const {message, created_at, is_read, id} = props;
  const dispatch = useDispatch();

  const handleClick = (e) => {
    e.stopPropagation();
    if (!is_read) {
      dispatch(markNotificationAsRead(id));
    }
  };

  return (
    <DropdownItem
      style={{padding: "0.5rem", pointerEvents: "all"}}
      className="notification-item"
    >
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <div
            className={`notification-status ${
              is_read ? "notification-read" : "notification-unread"
            }`}
          ></div>
          <div
            className={"notification-message"}
            id={`message-${id}`}
            onClick={handleClick}
            style={{cursor: is_read ? "text" : "pointer"}}
          >
            {message}
          </div>
          {!is_read && (
            <UncontrolledTooltip
              target={`message-${id}`}
              key={`message-${id}`}
              placement={"auto"}
            >
              {"Mark as read"}
            </UncontrolledTooltip>
          )}
        </div>
        <small className="notification-time float-right">
          {moment(created_at).fromNow(false)}
        </small>
      </div>
    </DropdownItem>
  );
};

NotificationItem.propTypes = {
  /** Notification message */
  message: PropTypes.string.isRequired,
  /** Notification created date */
  created_at: PropTypes.string.isRequired,
  /** Notification read status */
  is_read: PropTypes.bool.isRequired,
  /** Notification id */
  id: PropTypes.number.isRequired,
};

export default NotificationItem;
